import { AudioBar } from './components/AudioBar';
import { AudioMenu, MenuItems } from './components/AudioMenu';
import { PlayButton } from './components/PlayButton';
export { QuickAudioPlayer } from './components/QuickAudioPlayer';
export var AudioPlayer = {
  AudioBar: AudioBar,
  PlayButton: PlayButton,
  AudioMenu: AudioMenu,
  MenuItems: MenuItems
};